import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, PenLine } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusPill, useBlogSettings } from "@/components/blog/BlogBits";
import { timeAgo } from "@/lib/format";

export function BlogPostsTab() {
  const { data: settings } = useBlogSettings();
  const { data } = useQuery({ queryKey: ["blog-mine"], queryFn: async () => (await api.get("/blog/mine")).data });
  const posts = data?.posts || [];
  if (posts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border py-20 text-center" data-testid="blog-tab-empty">
        <PenLine className="h-10 w-10 text-muted-foreground" />
        <p className="mt-4 font-serif text-2xl text-foreground">Share your perspective</p>
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">Write about a question that changed how you see God. Posts are reviewed before they go live.</p>
        {settings?.enabled !== false && (
          <Link to="/blog/write"><Button className="mt-6 rounded-full bg-primary text-primary-foreground" data-testid="dashboard-start-blog">Write a post <ArrowRight className="ml-1 h-4 w-4" /></Button></Link>
        )}
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="blog-tab-list">
      <div className="flex justify-end">
        <Link to="/blog/mine" className="inline-flex items-center gap-1 text-sm text-primary hover:underline" data-testid="dashboard-open-blog-mine">Manage all posts <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      {posts.slice(0, 6).map((p) => (
        <Link key={p.id} to={p.status === "published" ? `/blog/${p.slug}` : `/blog/edit/${p.id}`} data-testid={`dash-post-${p.id}`} className="flex items-center justify-between gap-3 rounded-2xl border border-border bg-card p-4 transition-all hover:border-gold hover:shadow-md">
          <div className="min-w-0">
            <p className="truncate font-serif text-lg text-foreground">{p.title}</p>
            <p className="mt-1 flex items-center gap-2 text-xs text-muted-foreground"><StatusPill status={p.status} /> <span>{timeAgo(p.updated_at || p.created_at)}</span></p>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground" />
        </Link>
      ))}
    </div>
  );
}
